import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../services/global.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ModelRegistrationComponent } from '../models/model-registration/model-registration.component';
import { FlowSheetService } from '../services/flowsheet-service';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { MLService } from '../services/ml-service';
import { AlertComponent } from '../common/alert/alert.component';
import { Globals } from '../models/globals.model';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { FilterFieldTypes } from '../common/common-constants';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DataSourceManagerComponent } from '../data-source-manager/data-source-manager.component';
import { TenantService } from '../services/tenant.service';

@Component({
  selector: 'app-model-management',
  templateUrl: './model-management.component.html',
  styleUrls: ['./model-management.component.css']
})
export class ModelManagementComponent implements OnInit, OnDestroy {
  resourceList: any = [];
  accessTokenModel: any;
  expandedIndex: any;
  stringLimit = 20;
  isLoading = true;
  modelErrorMessage = 'Error';
  isModelErrorApp = false;
  isModelErrorAPI = false;
  isModelErrorOps = false;
  isModelErrorService = false;
  modelDetails: any;
  selectedItem: string = 'All';
  modelType: string[] = ['All', 'Surrogate', 'AIML', 'Simulator'];
  modelListDetails: MatTableDataSource<any>;
  selection = new SelectionModel<any>(false, []);
  displayedColumns: string[] = ['modelName', 'modelTypeName', 'modelVersion', 'businessDescription', 'businessFunctionTypeName', 'action'];
  isLinear = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  selModelToDelete: any;
  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;
  public destroyed = new Subject<any>();

  constructor(
    public router: Router,
    public globals: Globals,
    public globalService: GlobalService,
    public httpClientObj: HttpClient,
    public flowsheetService: FlowSheetService,
    public mlService: MLService,
    private readonly tenantService: TenantService,
    public dialog: MatDialog) {
    const emptyList: any[] = [];
    this.modelListDetails = new MatTableDataSource(emptyList);
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      this.initialize();
    });
  }

  initialize() {
    this.expandedIndex = -1;
    let serviceTenant:any = this.tenantService.getCurrentTenant();    
    if (serviceTenant?.tenantId && serviceTenant.tenantId > 0) {
      this.mlService.geAuthCode().subscribe((data: any): void => {
        this.isLoading = true;
        this.isModelErrorApp = false;
        this.accessTokenModel = data.accessToken;
        this.getListofModel();
      }, (error: Error) => {
        console.log('Error while getting Bearer token, more details: ', error.message);
      });
    }    
  }

  ngOnInit() {
    // 'ngOnInit' should not be empty
  }

  getListofModel() {
    this.selectedFilters = [];
    this.mlService.getModelList().subscribe((data: any): void => {
      if (data && data !== null && data.length > 0) {
        this.masterData = [...data];
        this.modelListDetails = new MatTableDataSource(data);
        this.modelListDetails.sort = this.sort;
        this.modelListDetails.paginator = this.paginator;
        this.isLoading = false;
      }
      else {
        this.modelListDetails.data = [];
      }
      this.isLoading = false;
      this.createFilterList();
    }, (error: Error) => {
      this.globalService.showAlert(AlertComponent, { success: false, message: "Error in fetching model repository" });
      this.isLoading = false;
    });
  }

  checkIfEmpty(objectPassed) {
    return objectPassed.length > 0;
  }

  truncateString(str) {
    if (str.length <= this.stringLimit) {
      return str;
    } else {
      return str.slice(0, this.stringLimit) + '...';
    }
  }

  filterTenantsModel(dataset, currentTenantName, currentRefinery) {
    return dataset.filter(x => x.kvTags.Location == currentRefinery && x.kvTags.TenantName == currentTenantName);
  }

  modefiedList(dataset) {
    const listDataModel = dataset;
    for (let i = 0; i < listDataModel.length; i++) {
      let tags = [];
      if (listDataModel[i].description) {
        listDataModel[i].description = listDataModel[i].description.replace(/\[([^[\]]*)\]/g, function ($0, $1) { tags.push($1); return ''; });
        if (tags.length > 0) {
          listDataModel[i].type = tags[0];
          listDataModel[i].function = tags[1];
          listDataModel[i].availalbleModel = {
            name: tags[2],
            properties: {
              urlTemplate: tags[3]
            }
          };
          listDataModel[i].baseModelIdName = tags[4];
        } else {
          console.log("Tags is not available");
        }
      } else {
        console.log("Description is not available");
      }
    }
    return dataset;
  }

  erroHandlingModel(msg, error) {
    this.isModelErrorApp = true;
    this.modelErrorMessage = msg + error;
  }

  erroHandlingModSer(msg, error) {
    this.isModelErrorService = true;
    this.modelErrorMessage = msg + error;
  }

  erroHandlingModAPI(msg, error) {
    this.isModelErrorAPI = true;
    this.modelErrorMessage = msg + error;
  }

  erroHandlingModOps(msg, error) {
    this.isModelErrorOps = true;
    this.modelErrorMessage = msg + error;
  }

  erroHandlingModApp(error) {
    this.isModelErrorApp = false;
    this.modelErrorMessage = 'Error is: ' + error;
  }

  erroHandSerForApp(error) {
    this.isModelErrorApp = false;
    this.modelErrorMessage = 'Error is: ' + error;
  }

  erroHandAPIForApp(error) {
    this.isModelErrorApp = false;
    this.modelErrorMessage = 'Error is: ' + error;
  }

  erroHandOpsForApp(error) {
    this.isModelErrorApp = false;
    this.modelErrorMessage = 'Error is: ' + error;
  }

  filterModel(newValue) {
    this.selectedItem = newValue;
  }

  selectRow(row) {
    this.selection.toggle(row);
  }

  removeErrorMessage() {
    this.isModelErrorApp = false;
    this.isModelErrorService = false;
    this.isModelErrorAPI = false;
    this.isModelErrorOps = false;
  }

  deleteModel(selectedModel) {
    this.isLoading = true;
    this.selModelToDelete = selectedModel;
    let message = "";
    this.flowsheetService.getFlowSheetsByModelDetails(selectedModel.modelId).subscribe((data: any) => {
      this.isLoading = false;
      if (data.length > 0) {
        this.globalService.showAlert(AlertComponent, { success: false, message: "This model is being used in Flowsheet(s). Deleting it will cause those flowsheets to malfunction. So you can not delete " + selectedModel.modelName + "model." });
      }
      else {
        let dataToPass = {
          title: 'Delete',
          isDelete: true,
          message: message + ' Do you really want to delete this model?'
        };
        this.globalService.openModelWindow(this.deleteOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
      }
    });
  }

  deleteOnConfirm(thisRef: ModelManagementComponent) {
    thisRef.isLoading = true;
    const httpOptions = thisRef.globalService.gethttpHeader(thisRef.accessTokenModel);
    let selModelDeleteId = thisRef.selModelToDelete.id;
    thisRef.mlService.deleteModelData(selModelDeleteId, httpOptions).subscribe((data: any): void => {
      thisRef.mlService.deleteModelMasterData(thisRef.selModelToDelete.modelId, thisRef.selModelToDelete.modelConfigrationId).subscribe((data: any) => {
        thisRef.selection.clear();
        thisRef.getListofModel();
      });
    }, (error: Error) => {
      thisRef.erroHandlingModSer('Error in deleting model' + thisRef.selModelToDelete.modelName + '. More details: ', error.message);
      thisRef.isLoading = false;
    });
  }

  openDialog(ops, modelData?) {
    let dataToPass = {
      'selectedData': ops === 'editModel' || 'viewModel' ? modelData : '',
      'modelAction' : ops,
      'accessToken': this.accessTokenModel
    };
    this.openModelWindow(ModelRegistrationComponent, '70%', 'custom-modalbox', dataToPass);
  }

  openModelExec(modelDetails) {
    let dataToPass = {
      'name': modelDetails.modelName,
      'version': modelDetails.modelVersion,
      'modelType': modelDetails.modelTypeName,
      'availalbleModel': modelDetails.availalbleModel,
      'accessToken': this.accessTokenModel,
      'modelId': modelDetails.modelId,
      'modelConfigrationId': modelDetails.modelConfigrationId
    };
    if (modelDetails.modelTypeName == "AIML") {
      this.globalService.showAlert(AlertComponent, { success: false, message: "This feature is not available for " + modelDetails.modelTypeName + " type model." });
    } else {
      this.openModelWindow(DataSourceManagerComponent, '80%', 'custom-modalbox', dataToPass);
    }

  }

  openModelWindow(modelComponent, widthOfWindow, panleClassName, dataToPass) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panleClassName,
        data: dataToPass
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isLoading = true;
          this.selection.clear();
          this.getListofModel();
        }
      });
    }
  }

  /**
   * Filters data based on input text
   * @param filterValue
   */
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase(); // Remove whitespace and MatTableDataSource defaults to lowercase matches
    this.modelListDetails.filter = filterValue;
  }

  /**Creates data for filter list */
  createFilterList() {
    this.filterList = [];
    for (let a = 0; a < this.displayedColumns.length - 1; a++) {
      let tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldName = this.globalService.replaceDisplayText(this.displayedColumns[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      if (this.displayedColumns[a] == "modelName") {
        unique = [...new Set(this.modelListDetails.data.map(a => a.modelName))];
      } else if (this.displayedColumns[a] == "modelTypeName") {
        unique = [...new Set(this.modelListDetails.data.map(a => a.modelTypeName))];
      } else if (this.displayedColumns[a] == "modelVersion") {
        unique = [...new Set(this.modelListDetails.data.map(a => a.modelVersion))];
      } else if (this.displayedColumns[a] == "businessDescription") {
        unique = [...new Set(this.modelListDetails.data.map(a => a.businessDescription))];
      } else if (this.displayedColumns[a] == "businessFunctionTypeName") {
        unique = [...new Set(this.modelListDetails.data.map(a => a.businessFunctionTypeName))];
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.modelListDetails.data = this.globalService.conditionalDataFiltering(filterResponse, this.modelListDetails.data);
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.modelListDetails.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.modelListDetails.data = this.globalService.conditionalDataFiltering(element, this.modelListDetails.data);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

}

